import type { PropsWithChildren } from 'react';

import { SplitFactoryProvider } from '@splitsoftware/splitio-react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ThemeProvider } from '@mui/material/styles';

import { queryClient } from '@/shared/libs';
import { splitConfig } from './feature-flags';
import { InfiniteWatchProvider } from './InfiniteWatchScript';
import { materialTheme } from '@/shared/styles';

export function ApplicationProviders({ children }: PropsWithChildren) {
  return (
    <SplitFactoryProvider config={splitConfig}>
      <InfiniteWatchProvider />
      <ThemeProvider theme={materialTheme}>
        <QueryClientProvider client={queryClient}>
          {children}
          <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
        </QueryClientProvider>
      </ThemeProvider>
    </SplitFactoryProvider>
  );
}
